import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { ToastMessageTitle, ToastMessageContentSuppliers } from './PreferredSuppliersToastMessage';

const getTitleAndContentForToastMessage = ({ addedSuppliers, deletedSuppliers }) => {
  if (!isEmpty(addedSuppliers) && isEmpty(deletedSuppliers)) {
    return {
      title: <ToastMessageTitle title="New supplier added to your preferences" />,
      content: <ToastMessageContentSuppliers suppliers={addedSuppliers} added />,
    };
  }

  if (isEmpty(addedSuppliers) && !isEmpty(deletedSuppliers)) {
    return {
      title: <ToastMessageTitle title="Supplier deleted from your preferences" />,
      content: <ToastMessageContentSuppliers suppliers={deletedSuppliers} />,
    };
  }

  return {
    title: <ToastMessageTitle title="A change was made to your supplier preferences" />,
    content: (
      <>
        <ToastMessageContentSuppliers suppliers={addedSuppliers} added bold />{' '}
        <ToastMessageContentSuppliers suppliers={deletedSuppliers} bold />
      </>
    ),
  };
};

export default getTitleAndContentForToastMessage;
